import {IWebsiteSidebarItem, WebsiteSidebarItem} from "../website-sidebar-item.model";
import {IWebsiteSidebarSimpleItem} from "../website-sidebar-simple-item/website-sidebar-simple-item.model";

export interface IWebsiteSidebarSubMenu extends IWebsiteSidebarItem {
  subMenu?: IWebsiteSidebarSimpleItem[];
  toggled: boolean;
  advanced?: boolean;

  setPageIds: (pageIds: string[]) => void;
  toggle: (routerLink?: string) => void;
}

export class WebsiteSidebarSubMenu extends WebsiteSidebarItem implements IWebsiteSidebarSubMenu {
  public subMenu?: IWebsiteSidebarSimpleItem[];
  public toggled: boolean = false;
  public advanced?: boolean = false;
  private pageIds?: string[];

  constructor(
    name: string,
    label: string,
    type: 'static' | 'dropdown' | 'accordion',
    img?: string,
    icon?: string,
    subMenu?: IWebsiteSidebarSimpleItem[],
    pageIds?: string[],
    disabled?: boolean,
    advanced?: boolean,
  ) {
    super(name, label, type, img, icon, disabled, advanced);
    subMenu && (this.subMenu = subMenu);
    pageIds && (this.pageIds = pageIds);
    advanced && (this.advanced = advanced);
  }

  public setPageIds(pageIds: string[]): void {
    this.pageIds = pageIds;
  }

  public toggle(routerLink?: string): void {
    if (routerLink) {
      this.toggled = this.pageIds && this.pageIds.includes(routerLink);
    }
    else {
      this.toggled = !this.toggled;
    }
  }
}
